import axios from "axios";
import React, { useEffect, useState } from "react";

import config from '../config';
import { headers } from "../token";

import { Link } from "react-router-dom";

import vAdminformat from "../adminFormat";


const server_backend = config.API_URL;

const Profile = ({ username, userRole }) => {
    const [Profile, setProfile] = useState([])

    useEffect(() => {

        const getProfile = async () => {

            try {

                const response = await axios.get(`${server_backend}/users/profile?email=${username}`, headers);
                setProfile(response.data.RES_RESULT);
            } catch (error) {
                console.log(error);
            }
        }
        getProfile();

    }, [0]);

    return (

        <div className="page-content">
            <div className="container-fluid">
                <div className="profile-foreground position-relative mx-n4 mt-n4">
                    <div className="profile-wid-bg">
                        <img src="assets/images/profile-bg.jpg" alt="" className="profile-wid-img" />
                    </div>
                </div>
                <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
                    <div className="row g-4">
                        <div className="col-auto">
                            <div className="avatar-lg">
                                <img src="assets/images/users/user-dummy-img.jpg" alt="user-img" className="img-thumbnail rounded-circle" />
                            </div>
                        </div>
                        {/*end col*/}
                        <div className="col">
                            <div className="p-2">
                                <h3 className="text-white mb-1">{`${Profile.name} ${Profile.lastname}`}</h3>
                                <p className="text-white-75">{Profile.Comment}</p>
                                <div className="hstack text-white-50 gap-1">
                                    <div className="me-2"><i className="ri-map-pin-user-line me-1 text-white-75 fs-16 align-middle"></i>{`${Profile.branchs_city}, ${Profile.branchs_country}`}</div>
                                    <div><i className="ri-building-line me-1 text-white-75 fs-16 align-middle"></i>{Profile.branchs_address}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*end row*/}
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <div>

                            {/* Nav tabs */}

                            <div class="d-flex">
                                <ul class="nav nav-pills animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1" role="tablist">
                                    <li class="nav-item">
                                    </li>
                                </ul>
                                <div class="flex-shrink-0" >
                                    <Link class="btn btn-success" to="/change-password"><i class="ri-edit-box-line align-bottom"></i> Change Password</Link>
                                </div>
                            </div>

                            <div class="tab-content pt-4 text-muted">
                                <div class="tab-pane active" id="overview-tab" role="tabpanel">
                                    <div class="row">
                                        <div className="col-5">
                                            {/*  <div className="card">
                                                <div className="card-body">
                                                    <h5 className="card-title mb-5">Complete Your Profile</h5>
                                                    <div className="progress animated-progress custom-progress progress-label">
                                                        <div className="progress-bar bg-danger" role="progressbar" style={{ width: '30%' }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                                                            <div className="label">30%</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}

                                            <div className="card">
                                                <div className="card-body">
                                                    <h5 className="card-title mb-3">Info</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-borderless mb-0">
                                                            <tbody>
                                                                <tr>
                                                                    <th className="ps-0" scope="row">Username :</th>
                                                                    <td className="text-muted">{Profile.usr_codigo}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="ps-0" scope="row">Full Name :</th>
                                                                    <td className="text-muted">{`${Profile.name} ${Profile.lastname}`}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="ps-0" scope="row">DNI :</th>
                                                                    <td className="text-muted">{Profile.dni}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="ps-0" scope="row">Mobile :</th>
                                                                    <td className="text-muted">{Profile.branchs_phone}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="ps-0" scope="row">E-mail :</th>
                                                                    <td className="text-muted">{Profile.email}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="ps-0" scope="row">Location :</th>
                                                                    <td className="text-muted">{`${Profile.branchs_city}, ${Profile.branchs_country}`}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="ps-0" scope="row">Joining Date</th>
                                                                    <td className="text-muted">{vAdminformat.FormatDate(Profile.date_created)
                                                                    }</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-7">
                                            <div className="card">
                                                <div className="card-body">
                                                    <h5 className="card-title mb-3">About</h5>
                                                    <p>{Profile.comment}</p>

                                                    <div className="row">
                                                        <div className="col-6 col-md-4">
                                                            <div className="d-flex mt-4">


                                                            </div>
                                                        </div>
                                                        {/*end col*/}
                                                        <div className="col-12 ">
                                                            <div className="row">
                                                                <div className="col-4">
                                                                    <p className="mb-1">Designation :</p>
                                                                    <h6 className="text-truncate mb-0">{userRole}</h6>
                                                                </div>
                                                                <div className="col-4">
                                                                    <p className="mb-1">Department:</p>
                                                                    <a href="#" className="fw-semibold">{Profile.department}</a>
                                                                </div>
                                                                <div className="col-4">
                                                                    <p className="mb-1">Branch:</p>
                                                                    <a href="#" className="fw-semibold">{Profile.branchs_name}</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/*end col*/}
                                                    </div>
                                                    {/*end row*/}
                                                </div>
                                                {/*end card-body*/}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Profile;